var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.1 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55637"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h97.1v24H0z",
    "data-name": "Rectangle 17132"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54972"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54915"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15284",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m4.862 7.604.572-.693a2.008 2.008 0 0 0 1.314.54c.4 0 .635-.159.635-.432 0-.248-.151-.375-.887-.566-.887-.229-1.459-.477-1.459-1.373a1.382 1.382 0 0 1 1.541-1.341 2.531 2.531 0 0 1 1.635.566l-.5.737a2.051 2.051 0 0 0-1.144-.439c-.371 0-.566.172-.566.4 0 .292.189.388.95.585.893.235 1.4.559 1.4 1.348 0 .883-.667 1.379-1.616 1.379a2.784 2.784 0 0 1-1.875-.711Z",
    "data-name": "Path 18558"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M6.732 8.522a2.985 2.985 0 0 1-2.006-.765l-.147-.132.83-1 .159.133a1.786 1.786 0 0 0 1.182.492c.129 0 .429-.022.429-.226 0-.083 0-.176-.732-.366-.883-.228-1.613-.5-1.613-1.572a1.584 1.584 0 0 1 1.747-1.547 2.729 2.729 0 0 1 1.765.612l.147.12-.728 1.067-.171-.12a1.836 1.836 0 0 0-1.026-.4c-.084 0-.36.014-.36.194 0 .112 0 .179.8.385s1.551.546 1.551 1.547a1.607 1.607 0 0 1-1.822 1.578Zm-1.578-.945a2.58 2.58 0 0 0 1.578.532c.883 0 1.41-.439 1.41-1.173 0-.606-.325-.906-1.242-1.148-.64-.166-1.1-.286-1.1-.784 0-.3.239-.607.772-.607a2.062 2.062 0 0 1 1.089.361l.277-.406a2.339 2.339 0 0 0-1.353-.406 1.18 1.18 0 0 0-1.334 1.135c0 .72.384.936 1.3 1.173.706.183 1.041.344 1.041.765 0 .309-.221.638-.841.638a2.1 2.1 0 0 1-1.283-.46Z",
    "data-name": "Path 18558 - Outline"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M10.117 4.705H8.778v-.9h3.647v.9h-1.339v3.547h-.968Z",
    "data-name": "Path 18559"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M8.572 3.596h4.06v1.315h-1.339v3.546H9.912V4.91H8.573Zm3.647.412H8.985v.49h1.339v3.547h.556V4.498h1.339Z",
    "data-name": "Path 18559 - Outline"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M12.783 6.029a2.338 2.338 0 1 1 2.332 2.3 2.288 2.288 0 0 1-2.332-2.3Zm3.664 0a1.345 1.345 0 0 0-1.332-1.4 1.328 1.328 0 0 0-1.32 1.4 1.345 1.345 0 0 0 1.333 1.4 1.328 1.328 0 0 0 1.319-1.4Z",
    "data-name": "Path 18560"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M15.127 3.516a2.468 2.468 0 0 1 2.538 2.508 2.5 2.5 0 0 1-2.551 2.508 2.468 2.468 0 0 1-2.538-2.508 2.5 2.5 0 0 1 2.551-2.508Zm-.013 4.6a2.1 2.1 0 1 0-2.126-2.1 2.071 2.071 0 0 0 2.127 2.108Zm0-3.7a1.556 1.556 0 0 1 1.539 1.6 1.533 1.533 0 0 1-1.526 1.6 1.556 1.556 0 0 1-1.539-1.6 1.533 1.533 0 0 1 1.527-1.592Zm.013 2.8a1.117 1.117 0 0 0 1.113-1.193 1.135 1.135 0 0 0-1.126-1.193A1.117 1.117 0 0 0 14 6.023a1.135 1.135 0 0 0 1.127 1.2Z",
    "data-name": "Path 18560 - Outline"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M18.319 3.802h2.012a1.743 1.743 0 0 1 1.283.451 1.416 1.416 0 0 1 .377 1.03 1.381 1.381 0 0 1-.943 1.379l1.075 1.589h-1.132l-.956-1.424h-.748v1.424h-.968Zm1.949 2.161c.472 0 .742-.254.742-.642 0-.42-.289-.636-.761-.636h-.962v1.278Z",
    "data-name": "Path 18561"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M18.113 3.596h2.218a1.955 1.955 0 0 1 1.429.512 1.626 1.626 0 0 1 .437 1.175 1.57 1.57 0 0 1-.841 1.466l1.156 1.708h-1.63l-.956-1.424h-.432v1.424h-1.381Zm3.621 4.449-1-1.484.245-.092a1.178 1.178 0 0 0 .809-1.186 1.208 1.208 0 0 0-.318-.885 1.537 1.537 0 0 0-1.136-.39h-1.806v4.037h.556V6.621h1.064l.956 1.424Zm-2.653-3.566h1.168c.6 0 .967.323.967.842a.845.845 0 0 1-.948.848h-1.187Zm1.187 1.278c.2 0 .536-.057.536-.436 0-.106 0-.429-.554-.429h-.756v.865Z",
    "data-name": "Path 18561 - Outline"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m23.946 6.497-1.691-2.7h1.132l1.05 1.786 1.069-1.786h1.1l-1.691 2.676v1.773h-.968Z",
    "data-name": "Path 18562"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M25.121 8.457H23.74v-1.9l-1.858-2.961h1.621l.934 1.588.95-1.588h1.591l-1.859 2.942Zm-.968-.412h.556V6.418l1.523-2.41h-.609l-1.187 1.984-1.166-1.984h-.641l1.525 2.429Z",
    "data-name": "Path 18562 - Outline"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15285",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c6972",
    d: "M1.937 3.29H.205V1.955h1.732V.213h1.359v1.742h1.732V3.29H3.296v1.742H1.937Z",
    "data-name": "Path 18565"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M3.505 5.234H1.734V3.49H.005V1.742h1.732V0h1.768v1.742h1.732V3.49H3.505Zm-1.359-.413h.946V3.08h1.732v-.923H3.092V.415h-.946v1.742H.414v.923h1.732Z",
    "data-name": "Path 18565 - Outline"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c6972",
    d: "M4.852 9.832h2.386l2.645 4.3 2.645-4.3h2.386v10.176h-2.2v-6.643l-2.832 4.346h-.058l-2.8-4.3v6.6H4.852Z",
    "data-name": "Path 19285"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M4.647 9.626h2.705l2.53 4.115 2.53-4.115h2.708v10.589h-2.612V14.06l-2.514 3.858h-.281l-2.485-3.815v6.112H4.645Zm2.477.413H5.059v9.764h1.758v-7.088l3.038 4.664 3.067-4.707v7.132h1.787V10.04h-2.065l-2.761 4.491Z",
    "data-name": "Path 19285 - Outline"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c6972",
    d: "M17.331 9.832h3.921a5.094 5.094 0 1 1 0 10.176h-3.925Zm3.921 8.155a3.068 3.068 0 1 0 0-6.135h-1.711v6.135Z",
    "data-name": "Path 19286"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M17.125 9.626h4.127a5.251 5.251 0 0 1 5.554 5.294 5.188 5.188 0 0 1-1.554 3.767 5.684 5.684 0 0 1-4 1.528h-4.131Zm4.131 10.176a4.888 4.888 0 1 0 0-9.764h-3.718v9.764Zm-1.917-8.155h1.913a3.116 3.116 0 0 1 3.24 3.274 3.276 3.276 0 0 1-.9 2.366 3.2 3.2 0 0 1-2.343.908h-1.917Zm1.913 6.14a2.861 2.861 0 1 0 0-5.722h-1.5v5.722Z",
    "data-name": "Path 19286 - Outline"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M40.124 18.505h-2.739v-5.592h-5.131v5.592h-2.747V5.548h2.747v5.078h5.131V5.548h2.738Zm10.732 0h-7.462V5.548h7.462v2.251h-4.715v2.845h4.387v2.251h-4.387v3.341h4.715Zm10.635 0-.939-3.084h-4.724l-.94 3.084h-2.96l4.573-13.01h3.359l4.591 13.01Zm-1.6-5.388q-1.3-4.192-1.467-4.741t-.23-.871q-.292 1.134-1.675 5.61Zm6.19 5.388V5.548h2.747v10.688h5.255v2.269Zm14.889 0h-2.747V7.835h-3.519V5.549h9.784v2.286H80.97Zm16.129 0h-2.738v-5.592H89.23v5.592h-2.748V5.548h2.747v5.078h5.131V5.548h2.738Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHealth);
export default __webpack_public_path__ + "static/media/logo-health.04dfa4d675a77be7a13aa6a5bf314ce8.svg";
export { ForwardRef as ReactComponent };